import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <Helmet>
        <title>Privacy Policy - Topup Connect</title>
        <meta
          name="description"
          content="Privacy Policy of Topup Connect, operated by CHOTTU TELECOM."
        />
      </Helmet>

      <h1>Privacy Policy</h1>
      <p className="effective-date">Last Updated: 01.01.2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy applies to Topup Connect, a brand operated by{" "}
          <strong>CHOTTU TELECOM</strong>, located at Barasat - 1, Kathuria,
          Malikapur, Duttapukur, Barasat, North 24 Parganas, West Bengal -
          700126. By accessing or using our platform and services, you agree to
          the terms of this Privacy Policy.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          To provide our recharge and digital services, we collect the following
          data:
        </p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, phone number, email
            address
          </li>
          <li>
            <strong>Transaction Details:</strong> Mobile/DTH numbers,
            transaction history, payment details
          </li>
          <li>
            <strong>Device & Technical Data:</strong> IP address, browser type,
            device ID, OS, geolocation
          </li>
          <li>
            <strong>SMS/OTP:</strong> Used for secure authentication, only with
            your consent
          </li>
          <li>
            <strong>Referral or Invite Data:</strong> If you refer users or are
            referred by others
          </li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>To process recharges, bill payments, and wallet transactions</li>
          <li>To verify your identity and ensure secure access</li>
          <li>To communicate important service-related updates</li>
          <li>To personalize your user experience and offer promotions</li>
          <li>To detect and prevent fraud, abuse, or misuse of services</li>
          <li>To comply with regulatory and legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>4. Cookies & Tracking Technologies</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your
          experience, analyze usage, and personalize content. You can control
          cookie settings in your browser.
        </p>
      </section>

      <section>
        <h2>5. Data Sharing</h2>
        <p>We may share your data with:</p>
        <ul>
          <li>Payment gateways and banks to process payments</li>
          <li>Telecom and DTH providers for recharge fulfillment</li>
          <li>Third-party services for analytics, marketing, or support</li>
          <li>
            Law enforcement or regulatory authorities when legally required
          </li>
        </ul>
        <p>
          We ensure that these third parties maintain the confidentiality and
          security of your data.
        </p>
      </section>

      <section>
        <h2>6. Data Security</h2>
        <p>
          We employ industry-standard security practices to safeguard your
          information, including:
        </p>
        <ul>
          <li>End-to-end data encryption during transmission</li>
          <li>Secure servers and infrastructure</li>
          <li>Two-factor authentication (2FA) for sensitive actions</li>
          <li>Regular audits and vulnerability testing</li>
        </ul>
      </section>

      <section>
        <h2>7. Data Retention</h2>
        <p>
          We retain your data only as long as necessary to provide services and
          comply with legal or regulatory requirements. You may request deletion
          of your account at any time, subject to regulatory retention norms.
        </p>
      </section>

      <section>
        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal information held by us</li>
          <li>Request correction or update of inaccurate data</li>
          <li>Delete your account and data (where permitted by law)</li>
          <li>Withdraw consent for non-essential communications</li>
        </ul>
        <p>
          To exercise any of these rights, please contact us at the email
          provided below.
        </p>
      </section>

      <section>
        <h2>9. Children’s Privacy</h2>
        <p>
          Our services are not intended for use by children under the age of 18.
          We do not knowingly collect personal information from children.
        </p>
      </section>

      <section>
        <h2>10. Changes to This Policy</h2>
        <p>
          We may revise this Privacy Policy periodically. Updates will be posted
          on this page and major changes will be communicated through our app or
          website. Continued use of our services constitutes your agreement to
          the revised policy.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          For any privacy-related concerns or inquiries, reach out to us at:
          <br />
          <strong>Email:</strong> support@topupconnect.in
          <br />
          <strong>Address:</strong> Barasat - 1, Kathuria, Malikapur,
          Duttapukur, Barasat, North 24 Parganas, West Bengal - 700126
          <br />
          <strong>Legal Owner:</strong> CHOTTU TELECOM
        </p>
      </section>

      <div className="footer">
        <Link to="/">Back to Home</Link>
        <p>
          By continuing to use Topup Connect, you agree to our Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
